import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'nphs-wo-show-special-product',
    templateUrl: './show-special-product.component.html',
    styleUrls: ['./show-special-product.component.scss'],
    standalone: false
})
export class ShowSpecialProductComponent implements OnInit {
  details: any = {};

  constructor(public dialogRef: MatDialogRef<ShowSpecialProductComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata,) { }

  ngOnInit(): void {
    this.details = this.dialogdata.details; 
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
